import { useMutation } from "@tanstack/react-query"
import axios from "axios"
import {
  DataResponse,
  GetLoopReturnsReturnInfoSchema,
  GetReveniReturnResponseDataSchema,
} from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof GetReveniReturnResponseDataSchema>>

export function useLoopReturnsSearchReturnMutation() {
  return useMutation({
    mutationFn: async (data: z.infer<typeof GetLoopReturnsReturnInfoSchema>) => {
      return axios
        .post<Response>(`/integrations/loopreturns/search`, data)
        .then((response) => response.data.data)
    },
  })
}
